import { Routes } from '@angular/router';
import { DirectDownload } from '@app/features/contracts/direct-download/direct-download';
import { ContractLayout } from '@app/features/contracts/layout/contract-layout/contract-layout';
import { NotificationEventDetail } from '@app/features/notifications/notification-event-detail/notification-event-detail';
import { NotificationSettings } from '@app/features/notifications/notification-settings/notification-settings';
import { DemoStart } from '@app/features/tours/demo/demo-start';
import { ContractsDashboard } from './features/contracts/layout/contract-dashboard/contracts-dashboard';

export const routes: Routes = [
  {
    path: 'contrats',
    component: ContractsDashboard,
  },
  {
    path: 'contrats/:contractId',
    component: ContractLayout,
  },
  {
    path: 'contrats/:contractId/avenants/:amendmentId',
    component: ContractLayout,
  },
  {
    path: 'contrats/:contractId/direct-download',
    component: DirectDownload,
  },
  {
    path: 'reglages/notifications',
    component: NotificationSettings,
  },
  {
    path: 'reglages/notifications/:event',
    component: NotificationEventDetail,
  },
  {
    path: 'decouverte/:domain/:useCase',
    component: DemoStart,
  },
  {
    path: '**',
    redirectTo: 'contrats',
  },
];
